import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import http from "../../../../../utils/http";
import { GenerateLogo } from "../logoHelpers";
import { Button, Col, Row, Typography } from "antd";

const { Title } = Typography;

export default function DataProtection(props) {
  const companyId = useSelector((state) => state.companyConfig.company_id);
  const [dataProtection, setDataProtection] = useState("");
  const history = useHistory();
  const getFirstLoadDataProtection = async () => {
    const result = await http.get(`gastro/${companyId}/metadata`);
    setDataProtection(result?.data?.payload?.datenschutz);
  };

  useEffect(() => {
    if (companyId) {
      getFirstLoadDataProtection();
    }
  }, [companyId]);

  const goBack = () => {
    history.push("/public/welcome/form");
  };

  return (
    <div className="data-protection__wrapper">
      <Row justify="center">
        <Col md={0} lg={6}></Col>
        <Col md={24} lg={12} className="data-protection__container">
          <Row>
            <Col xs={24}>
              <div className="data-protection__logo__wrapper">
                <GenerateLogo className="data-protection__logo"/>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={24}>
              <div className="data-protection__body-header">
                <Title level={1} className="data-protection__title">
                  Datenschutz
                </Title>
                <Button primary onClick={goBack}>
                  Zurück zur Hub
                </Button>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={24}>
              <div className="data-protection__body">
                {dataProtection && (
                  <div dangerouslySetInnerHTML={{ __html: dataProtection }} />
                )}
              </div>
            </Col>
          </Row>
        </Col>
        <Col md={0} lg={6}></Col>
      </Row>
    </div>
  );
}
